let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8huvz")).then(() => parcelRequire('bWeXP'));